let font;

export default function getDefaultFont() {
    if (font === void 0 || document.readyState !== "complete") {
        font = window.getComputedStyle(document.body).fontFamily;
    }
    return font;
}


// WEBPACK FOOTER //
// ./src/lib/getDefaultFont.js